import api from '@edu-fe/api'

export default {
  name: 'pay',
  namespaced: true,
  state () {
    return {
      courseData: {},
      couponList: [],
      bonus: 0,
      isRetain: 0,
      courseResourceData: {
        iosPayCourseInfo: {},
        userResourceNumber: 0
      }
    }
  },
  mutations: {
    setCourseData: (state, data) => (state.courseData = data),
    setCouponList: (state, data) => (state.couponList = data),
    setCourseResourceData: (state, data) => (state.courseResourceData = data),
    setBouns: (state, data) => (state.bonus = data),
    setRetain: (state, data) => (state.isRetain = data)
  },
  actions: {
    getCourseData ({ commit }, { courseId }) {
      api.payment.getCourseData({
        courseId
      }).then(res => {
        commit('setCourseData', res.data)
      }).catch(err => console.error(err))
    },
    getCouponList ({ commit }, { courseId, type = 1 }) {
      api.payment.getCoupon({
        courseId, type
      }).then(res => {
        commit('setCouponList', res.data)
      }).catch(err => console.error(err))
    },
    async getRetain ({ commit }, { courseId }) {
      const { data } = await api.course.getRetain(courseId)()
      commit('setRetain', data)
    },
    async getBonus ({ commit }, { courseId }) {
      const { data = {} } = await api.wealth.getWealthData(courseId)()
      commit('setBouns', data.balance)
    },
    getResource ({ commit }, { courseId }) {
      api.payment.getResource({
        courseId
      }).then(res => {
        commit('setCourseResourceData', res.data)
      }).catch(err => console.error(err))
    },
    payByResource ({ commit }, { courseId }) {
      return api.payment.payByResource({
        courseId
      }).then(res => res).catch(err => console.error(err))
    },
    payByStage ({ commit }, { type = 1, courseId, isSend = 0 }) {
      return api.payment.payByStage({
        from: 'stage_pay',
        payWay: 11,
        type,
        courseId,
        isSend
      })
    }
  }
}
